import * as React from "react";

;
export const ChevronDownSmll = (props: React.SVGProps<SVGSVGElement>) => <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12 13.94l5.47-5.47 1.06 1.06L12 16.06 5.47 9.53l1.06-1.06L12 13.94z" fill="#100722" /></svg>;